import request from "@/router/axios";

const base = "/api/produce/shift-handover-record";

export const getList = (params = {}) =>
  request({
    url: `${base}/page`,
    method: "get",
    params,
  });

export const getDetail = (id) =>
  request({
    url: `${base}/detail`,
    method: "get",
    params: { id },
  });

export const save = (data) =>
  request({
    url: `${base}/save`,
    method: "post",
    data,
  });

export const update = (data) =>
  request({
    url: `${base}/update`,
    method: "post",
    data,
  });

export const remove = (ids) =>
  request({
    url: `${base}/remove`,
    method: "post",
    params: { ids },
  });

export const exportExcel = (data) =>
  request({
    url: `${base}/export`,
    method: "post",
    data,
    responseType: "blob",
  });

export const getTeamDict = () =>
  request({
    url: "/api/blade-system/dict-biz/dictionary",
    method: "get",
    params: { code: "base_team_type" },
  });

export const getShiftListByTeam = (teamNo) =>
  request({
    url: "/api/produce/team-shift-setting/list-by-team",
    method: "get",
    params: { teamNo },
  });
